import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpVentures'

export const scoreAxisList = (params = '') => Http.get(`/admin/venture-score-axes${serialize(params)}`)
export const scoreAxisCreate = (params = '') => Http.post('/admin/venture-score-axes', params)
export const scoreAxisByID = (params = '') => Http.get(`/admin/venture-score-axes/${params}`)
export const scoreAxisUpdate = (params = '') => Http.put(`/admin/venture-score-axes/${params.id}`, params)
export const scoreAxisDestroy = (params = '') => Http.delete(`/admin/venture-score-axes/${params.id}`)
